import React, {useEffect} from 'react';
import {includes} from 'ramda';
import {connect} from 'react-redux';

const mapStateToProps = state => {
    const {theme} = state.GeneralSettings;
    return {theme};
};

export default (WrappedComponent) => {
    const withThemeHOC = props => {
        useEffect(() => {
            const styles = document.head.querySelectorAll('style');
            styles.forEach(s => {
                const identifier = s.innerText.substring(0, 40);
                if (identifier.startsWith('@charset "UTF-8";\n/*')) {
                    if (!identifier.includes('Light')) {
                        s.disabled = !includes(props.theme, identifier);
                    }
                }
            });
        }, [props.theme]);

        return (
            <WrappedComponent theme={props.theme}/>
        );
    };

    return connect(mapStateToProps, null)(withThemeHOC);
};

